export default {
	sitePolicy: {
		updateSingle:
			'Wir haben unsere {link} aktualisiert, deswegen müssten Sie diese bitte erneut akzeptieren,',
		updateBoth:
			'um das Portal nutzen zu können, müssten Sie bitte zuerst unsere {tos} und die {privacy} zur Kenntnis nehmen',
		userData:
			'sowie gegebenenfalls {userLink} überprüfen. Bitte beachten Sie, sollten Sie noch weitere Einheiten und oder Liegenschaften bei anderen Verwaltern haben, die ebenfalls HausPerfekt MOBILE verwenden, könnten Ihnen diese Nutzungsbedingungen erneut angezeigt werden!',
		decline:
			'Sollten Sie mit den Bedingungen {bold} einverstanden sein, werden Ihre persönlichen Daten aus dem Portal gelöscht und Ihr Verwalter informiert.',
		yourData: 'Ihre Daten',
		tosAcknowledgement:
			'Ich habe die AGB / Nutzungsbedingungen gelesen und zur Kenntnis genommen.',
		privacyAcknowledgement:
			'Ich habe die Datenschutzerklärung gelesen und zur Kenntnis genommen.',
		multipleUsers:
			'Es sind mehrere Personen mit Ihrer E-Mail Adresse verknüpft. Treffen Sie bitte nachfolgend eine Auswahl.',
		userDataInfo:
			'Folgende Daten sind in diesem Portal über Sie hinterlegt oder mit Ihrer Person verknüpft.',
		acceptPrivacyTos:
			'Bitte akzeptieren Sie zuerst die Datenschutzerklärung und die Nutzungsbedingungen, um fortzufahren.',
		portalUsage: 'Nutzung des Portals',
		formalGreeting: 'Sehr geehrte Damen und Herren',
	},
}
